import { observer } from 'mobx-react-lite'
import { StyleSheet, View } from 'react-native'
import { useSafeAreaInsets } from 'react-native-safe-area-context'
import { useWalkthroughNextStep } from '../../../hooks/useWalkthroughNextStep'
import { useStore } from '../../../models'
import { DealTheFlop } from './Walkthroughs/DealTheFlop'
import { RaiseOrFold } from './Walkthroughs/RaiseOrFold'

import { TableTour } from './Walkthroughs/TableTour'

const Walkthroughs = {
  TableTour: TableTour,
  RaiseOrFold: RaiseOrFold,
  DealTheFlop: DealTheFlop
} as const

export const WalkthroughOverlay = observer(() => {
  const {
    game: { isFirstStep, walkthroughType, shouldDisplayWalkthroughOverlay }
  } = useStore()

  const insets = useSafeAreaInsets()
  useWalkthroughNextStep()

  if (!(walkthroughType && shouldDisplayWalkthroughOverlay)) return null

  const Content = Walkthroughs[walkthroughType]

  if (!Content) return null

  const displayBackdropWithFullColor = isFirstStep

  return (
    <View style={[styles.walkthroughOverlayContainer, { marginTop: insets.top }]}>
      <View
        style={[
          styles.backdrop,
          shouldDisplayWalkthroughOverlay ? styles.backdropWithColor : {},
          displayBackdropWithFullColor ? styles.backdropWithFullColor : {}
        ]}
      >
        <View style={styles.container}>
          <Content />
        </View>
      </View>
    </View>
  )
})

const styles = StyleSheet.create({
  backdrop: {
    flex: 1
  },
  backdropWithColor: {
    backgroundColor: 'rgba(123, 4, 61, 0.9)'
  },
  backdropWithFullColor: {
    backgroundColor: 'rgba(123, 4, 61, 1)'
  },
  container: {
    flex: 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%'
  },
  walkthroughOverlayContainer: {
    flex: 1,
    position: 'absolute',
    height: '100%',
    width: '100%',
    zIndex: 2
  }
})
